module.exports = __webpack_public_path__ + "static/media/email_icon.367b931c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/email_icon.svg
// module id = 323
// module chunks = 2